export const CASES = {
  UPDATE_OFFERS: "OFFERS/UPDATE_OFFERS",
  UPDATE_OFFERS_FILTERS: "OFFERS/UPDATE_OFFERS_FILTERS",
  SET_OFFERS_FILTERS: "OFFERS/SET_OFFERS_FILTERS",
  LOAD_OFFERS_FILTERS: "OFFERS/LOAD_OFFERS_FILTERS",
  CLEAR_OFFERS: "OFFERS/CLEAR_OFFERS",
  CLEAR_OFFERS_FILTERS: "OFFERS/CLEAR_OFFERS_FILTERS",
};

/** localStorage key prefix for persisting filters by jobId */
export const OFFERS_FILTERS_STORAGE_KEY = "tap_offers_filters_";
